import React, { memo } from 'react'
import styles from './SearchResultItem.module.scss'
import { Appliance } from '../../../../../../model/appliance'
import { ApplianceItem } from '../../../../../../model/solar-recommendation-form/appliance-item'
import { ApplianceCategory } from '../../../../../../model/appliance-category'

type AddingProps = {
    isSelected: boolean
    onAddAppliance: (appliance: Appliance) => void
    onRemoveAppliance: (appliance: Appliance) => void
}

type EditingProps = {
    appliance: ApplianceItem
    onEditAppliance: (appliance: ApplianceItem) => void
}

type Props = {
    appliance: Appliance
    isAdded: boolean
    addingProps?: AddingProps
    editingProps?: EditingProps
    onEditApplianceHandler?: () => void
    onDeleteApplianceHandler?: () => void
}

const SearchResultItem: React.FC<Props> = memo((props: Props) => {
    const { appliance, isAdded, addingProps, editingProps } = props

    function onChange() {
        if (addingProps!.isSelected) {
            addingProps!.onRemoveAppliance(appliance)
        } else {
            addingProps!.onAddAppliance(appliance)
        }
    }

    function onEdit() {
        editingProps!.onEditAppliance({
            ...editingProps!.appliance, editingProps: {
                ...editingProps!.appliance.editingProps,
                editing: true,
                newAppliance: appliance
            }
        })
    }

    return (
        <div className={styles.searchResultItem}>
            <div className={styles.searchResultItemInfo}>
                <div className={styles.division}>
                    <img src={appliance.iconUrl} alt={appliance.name} />
                    {appliance.name}
                </div>
                {
                    addingProps && <>
                        {
                            !isAdded ? <button className={`standardButton ${styles.button} ${addingProps!.isSelected && styles.removeButton}`} onClick={onChange} >
                                {addingProps!.isSelected ? 'Remove' : 'Add'}
                            </button> : <div className={`standardButton ${styles.button} ${styles.addedButton}`}>Added</div>
                        }
                    </>
                }
                {
                    editingProps && <>
                        {
                            !isAdded ? <button className={`standardButton ${styles.button}`} onClick={onEdit}>Change</button>
                                : <div className={`standardButton ${styles.button} ${styles.addedButton}`}>Added</div>
                        }
                    </>
                }
                {
                    (props.onEditApplianceHandler || props.onDeleteApplianceHandler) && <div className={styles.division}>
                        {
                            props.onEditApplianceHandler &&
                            <button className={`standardButton ${styles.submitButton}`} onClick={props.onEditApplianceHandler}>
                                Edit
                            </button>
                        }
                        {
                            props.onDeleteApplianceHandler &&
                            <button className={`standardButton ${styles.submitButton}`} onClick={props.onDeleteApplianceHandler}>
                                Delete
                            </button>
                        }
                    </div>
                }

            </div>
        </div>
    )
})

export default SearchResultItem